import { messaging } from "@/firebase";
import { getToken } from "firebase/messaging";

export const initializeFCM = () => {
	// Request permission to send notifications and get the FCM token
	Notification.requestPermission().then((permission) => {
		if (permission === "granted") {
			console.log("Notification permission granted.");
			getToken(messaging, { vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY })
				.then((currentToken) => {
					if (currentToken) {
						// Handle the FCM registration token as needed (e.g., send it to your server)
						console.log("FCM registration token:", currentToken);
					} else {
						console.log(
							"No registration token available. Request permission to generate one.",
						);
					}
				})
				.catch((err) => {
					console.error("Error retrieving FCM token", err);
				});
		} else {
			console.error("Permission not granted for Notifications");
		}
	});
};
